<script setup lang="ts">
  import { useScrollLock } from '@vueuse/core'

  const props = defineProps<{ modelValue: boolean }>()

  const emit = defineEmits(['update:modelValue'])
  const closeModal = () => {
    emit('update:modelValue', false)
  }

  const isScrollLocked = useScrollLock(document)

  watch(
    () => props.modelValue,
    (value) => {
      isScrollLocked.value = value
    }
  )

  const closeButton = ref<HTMLButtonElement | null>(null)
  onMounted(() => {
    if (closeButton.value) {
      closeButton.value.focus()
    }
  })
</script>
<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <div
      class="fixed top-0 size-full bg-black/75"
      @click="closeModal()"
    />
    <div
      class="fixed left-1/2 top-10 z-40 h-105 w-11/12 -translate-x-1/2 rounded-lg bg-white p-5 lg:!top-1/4 lg:!h-130 lg:!w-138 lg:!p-8"
    >
      <div class="flex w-full justify-end">
        <button
          ref="closeButton"
          class="absolute"
          :aria-label="$t('close')"
          @click="closeModal()"
        >
          <img src="/close.svg" />
        </button>
      </div>
      <div class="flex h-full flex-col items-center justify-center text-bt-blue-dark">
        <div class="relative mb-4 flex size-20 items-center justify-center md:!mb-10">
          <span class="absolute inline-flex size-3/4 animate-ping rounded-full bg-dark-success/75" />
          <span class="relative flex size-20 items-center justify-center rounded-full bg-dark-success text-white">
            <img src="/check.svg" />
          </span>
        </div>
        <h4 class="mb-2 text-h4 md:!mb-4">
          <slot name="title" />
        </h4>
        <p class="mb-14 text-center text-body-1 md:mb-10">
          <slot name="description" />
        </p>
        <div>
          <slot name="button" />
        </div>
      </div>
    </div>
  </div>
</template>
